export const engagementAppGroupIdSmsInboundMessageKeywordCategories =
  "/engagement/:app_group_id/sms_inbound_message_keyword_categories";
